import { BookOpen, LayoutGrid, ScrollText, Smartphone, Feather, Clapperboard, Gamepad2 } from "lucide-react";

const FORMATS = [
  { id: "books", icon: BookOpen, title: "Books", text: "Novels and non-fiction as Kindle ebook, paperback, hardcover and audiobook — proofread, rewritten and versioned." },
  { id: "comics", icon: LayoutGrid, title: "Comics", text: "AI-drawn panels from your script, draggable speech balloons, fixed-layout ebooks and full-bleed print PDFs." },
  { id: "manga", icon: ScrollText, title: "Manga", text: "Right-to-left reading, manga page layouts and lettering fonts, with a guided panel-zoom reader for phones." },
  { id: "webtoons", icon: Smartphone, title: "Webtoons", text: "Vertical-scroll episodes with release scheduling, countdowns and bookmarks that remember where readers stopped." },
  { id: "poetry", icon: Feather, title: "Poetry", text: "Poem templates, rhyme and rhythm checks, illustrated pages and readings with captions synced line by line." },
];

const SOON = [
  { id: "movies", icon: Clapperboard, title: "Movies" },
  { id: "games", icon: Gamepad2, title: "Games" },
];

const hex = "[clip-path:polygon(25%_0,75%_0,100%_50%,75%_100%,25%_100%,0_50%)]";

export const FormatsSection = () => (
  <section id="formats" className="max-w-7xl mx-auto px-4 sm:px-8 pt-24" data-testid="formats-section">
    <p className="eyebrow mb-4">What you can build</p>
    <h2 className="font-display text-3xl lg:text-4xl leading-tight max-w-2xl">One studio for every story you want to tell.</h2>
    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {FORMATS.map((f, i) => (
        <div key={f.id} className="fade-up group bg-slate-900/80 border border-amber-500/20 rounded-xl p-6 hover:border-amber-400/50 hover:-translate-y-1 transition-[transform,border-color] duration-300" style={{ animationDelay: `${i * 0.08}s` }} data-testid={`format-card-${f.id}`}>
          <div className={`w-11 h-11 mb-5 flex items-center justify-center bg-amber-800/40 group-hover:bg-amber-700/50 transition-colors ${hex}`}><f.icon className="text-amber-200" size={19} /></div>
          <h3 className="font-display text-lg font-semibold text-slate-100 mb-2">{f.title}</h3>
          <p className="text-sm text-slate-400 leading-relaxed">{f.text}</p>
        </div>
      ))}
    </div>
    <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-slate-400" data-testid="formats-coming-soon">
      <span className="eyebrow">Future expansions</span>
      {SOON.map((s) => (
        <span key={s.id} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-dashed border-amber-500/30 text-amber-200/80" data-testid={`format-soon-${s.id}`}>
          <s.icon size={14} /> {s.title} <span className="text-xs text-slate-500">coming soon</span>
        </span>
      ))}
    </div>
  </section>
);
